<template>
<div style="background: linear-gradient(#23242b, #08080a) !important;">
<header>
    <a @click="()=>$router.go(-1)" class="btn-back">
        <img src="@/assets/img/i-left-grey.png" alt="">
        返回
    </a>
    <span class="text-ellipsis">
        {{item.name}}
    </span>
    <a @click="handleCollect" :class="{'btn-collect':true,'on':item.collect}">
        <img   class="uncollected" src="@/assets/img/ic_collect.png" alt="">
        <img   class="collected" src="@/assets/img/ic_collect_on.png" alt="">
    </a>
</header>
<div class="main">
    <div class="mt">
        <div class="hd">
            <img :src="item.cover" style="height:2.34rem;" alt="">
            <p class="name">
                {{item.name}}
            </p>
            <p class="author">
                {{item.author}}
            </p>
        </div>
        <div class="md">
            <div class="scr">
                <h3>
                    简介
                </h3>
                <p>
                   {{item.summary}}
                </p>
            </div>
            <div class="publish">
                <p>
                    出版社：{{item.publishingHouse}}
                </p>
                <p>
                    ISBN：{{item.isbn}}
                </p>
                <!-- <p>
                    出版年：{{moment(item.publishingDate).format('YYYY-MM-DD')}}
                </p> -->
            </div>
        </div>
    </div>
    <div class="mb">
        <ul>
            <!-- <li>
                <a @click="handleReserve">
                    预约图书
                </a>
            </li> -->
            <li align="center">
                <a @clicl="jumpMap(marker) ">
                    图书位置
                </a>
            </li>
        </ul>
    </div>
    <div class="mask"></div>
     <div class="modal-item modal-unlogin" :style="{display:(uncollect?'block':'none')}">
        <p>
            您尚未登录，无法收藏哟(￣^￣)
        </p>
        <div class="opts">
            <a @click="()=>$router.push({name:'Login'})" class="btn-or btn-login">
                前去登录
            </a>
            <a @click="()=>uncollect=false" class="btn-grey-2 btn-see">
                再看看
            </a>
        </div>
    </div>
    <div class="modal-item modal-toplimit" :style="{display:(toplimit?'block':'none')}">
        <p>
            {{toast}}
        </p>
        <div class="opts">
            <a @click="()=>toplimit=false" class=" btn-sure">
                知道了
            </a>
        </div>
    </div>
        <div class="modal-item modal-againstMsg" :style="{display:(againstMsg?'block':'none')}">
        <div class="msg_box">
            <div class="user">
                <div class="user-i">
                    <img src="@/assets/img/yonghu.png" alt="">
                </div>
                <div class="user-name text-ellipsis">
                    用户：{{reserveMsg.nickname}}
                </div>
            </div>
            <div class="space">
                <div class="space-l">

                </div>
                <div class="space-r">
                </div>
            </div>
            <div class="msg-row">
                <div class="row-l">
                    <img src="@/assets/img/zhuangtai.png" alt="" class="img1">
                </div>
                <div class="row-r">
                    <p>
                        当前已借：{{reserveMsg.curBorrowBook}}
                    </p>
                    <p class="p2">
                        借书上限{{reserveMsg.bookMax}}本，已超限<span class="red">{{(reserveMsg.curBorrowBook - reserveMsg.bookMax)>0?(reserveMsg.curBorrowBook - reserveMsg.bookMax):0}}</span>本
                    </p>
                </div>
            </div>
            <div class="msg-row">
                <div class="row-l">
                    <img src="@/assets/img/weiguichuli.png" alt="" class="img1">
                </div>
                <div class="row-r">
                    <p>
                        注意：
                    </p>
                    <p class="p2">
                        违规<span class="red">{{reserveMsg.forbiddenNumber}}</span>次后将无法使用自助功能
                    </p>
                </div>
            </div>
        </div>
        <div class="opts">
            <a @click="()=>againstMsg=false" class="btn-sure">
                预定成功
            </a>
        </div>
    </div>
    <div class="modal-item modal-unlogin" :style="{display:(unlogin?'block':'none')}">
        <p>
            您尚未登录，无法预约哟(￣^￣)
        </p>
        <div class="opts">
            <a @click="()=>$router.push({name:'Login'})" class="btn-or btn-login">
                前去登录
            </a>
            <a @click="()=>unlogin=false"class="btn-grey-2 btn-see">
                再看看
            </a>
        </div>
    </div>
    <div class="modal-item modal-against"  :style="{display:(against?'block':'none')}">
        <p>
            您因违规达上限已被禁用自助功能
        </p>
        <div class="opts">
            <a href="##" class="btn-or btn-login">
                申请解禁
            </a>
            <a  @click="()=>against=false" class="btn-grey-2 btn-see">
                再看看
            </a>
        </div>
    </div>
</div>
</div>
</template>
<script>
// import $ from "jquery";
import moment from "moment";
import { getBook,bookCollect,reserveBook } from "@/api/book";
export default {
  data() {
    return {
      bookId: "",
      deviceId:"",
      item:{},
      unlogin:false,
      against:false,
      uncollect:false,
      againstMsg:false,
      toplimit:false,
      toast:'',
      reserveMsg:{}
    };
  },
  methods: {
      moment,
      handleBook(){
          getBook(this.bookId).then(res=>{
            this.item = res.data
             this.item.cover = process.env.VUE_APP_RESOURCE_API+this.item.cover
          })
      },
      handleCollect(){
        bookCollect(this.bookId).then(res=>{
            this.item.collect = !this.item.collect
        }).catch(error=>{
            console.log("error",error.response)
            if(error.response.status==401){
                this.uncollect = true
            }
        })
      },
      handleReserve(){
        reserveBook(this.deviceId,this.bookId).then(res=>{
            this.reserveMsg = res.data
            if(this.reserveMsg.sucflag){
              this.againstMsg = true
            }else{
              if(this.reserveMsg.errorType==0){
                  this.toplimit = true
                  this.toast = "您已达到预约上线，无法预约"
              }
              if(this.reserveMsg.errorType==1){
                  this.against = true
              }
              if(this.reserveMsg.errorType==2){
                  this.toplimit = true
                  this.toast = "您已被加入系统黑名单，请联系管理员"
              }
            }
        }).catch(error=>{
            console.log("error",error.response)
            if(error.response.status==400){
                this.toplimit = true
                this.toast=error.response.data.message
            }
            //未登录
            if(error.response.status==401){
                this.uncollect = true
            }
        })
      },
      jumpMap(marker) {
        console.log("jumpMap",marker)
      // window.location =
      //   "https://api.map.baidu.com/marker?location=" +
      //   marker.lat +
      //   "," +
      //   marker.lng +
      //   "&title=" +
      //   marker.name +
      //   "&output=html";
        wx.openLocation({
          latitude: Number(marker.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: Number(marker.lng), // 经度，浮点数，范围为180 ~ -180。
          name: marker.name, // 位置名
          address: marker.address, // 地址详情说明
          scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        });

    },
  },
  mounted() {
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }
    var deviceH= $(window).height();
        var hH= $("header").outerHeight();
        var mtH= $(".mt .hd").outerHeight();
        var publichH= $(".mt .publish").outerHeight();
        var mbH= $(".mb").outerHeight();

        $(".mt .scr").css("min-height",deviceH-hH-mtH-publichH-mbH);
    this.bookId = this.$route.query.id;
    this.deviceId = this.$route.query.deviceId
    this.handleBook()
  }
};
</script>
<style scoped>
header {
  position: fixed;
  text-align: center;
  padding-top: .32rem;
  background: #191a20;
  color: #d9d7dd;
}
header a {
  position: absolute;
  top: .32rem;
}
header a img {
  height: .24rem;
  vertical-align: middle;
  display: inline-block;
}
header .btn-back {
  left: .55rem;
  line-height: .24rem;
  color: #d9d7dd;
  font-size: .24rem;
}
header .btn-collect {
  right: .55rem;
  height: .24rem;
}
header .btn-collect .collected {
  display: none;
}
header .btn-collect .uncollected {
  display: block;
}
header .btn-collect.on .collected {
  display: block;
}
header .btn-collect.on .uncollected {
  display: none;
}
header .btn-collect img {
  height: .24rem;
}
header span {
  display: inline-block;
  width: 60%;
}
.main {
  padding-left: 0;
  padding-right: 0;
  padding-top: .9rem;
}
.main .mt .hd {
  background: #23242b;
  padding: .64rem .8rem .45rem;
  text-align: center;
}
.main .mt .hd img {
  width: 1.65rem;
  display: inline-block;
}
.main .mt .hd .name {
  margin: .4rem 0 0;
  font-size: .36rem;
  color: #d9d7dd;
  line-height: .5rem;
  font-family: HWXK;
}
.main .mt .hd .author {
  font-size: .24rem;
  color: #d9d7dd;
  line-height: .5rem;
  font-family: HWXK;
}
.main .mt .md {
  color: #d9d7dd;
  background: #191a20;
}
.main .mt .md .scr {
  padding: .32rem .55rem .23rem;
}
.main .mt .md .scr h3 {
  font-size: .34rem;
  text-align: center;
  margin-bottom: .2rem;
}
.main .mt .md .scr p {
  line-height: .5rem;
  font-size: .3rem;
  text-indent: 2em;
}
.main .mt .md .publish {
  border-top: 0.01rem solid #23242b;
  padding: .2rem;
  text-align: center;
  line-height: .5rem;
  font-size: .18rem;
  color: #d9d7dd;
}
.main .mb {
  padding: .35rem .88rem 0;
  background: #111216;
}
.main .mb ul {
  overflow: hidden;
}
.main .mb li {
  float: left;
  margin: 0 .33rem;
}
.main .mb li a {
  display: block;
  width: 2.2rem;
  text-align: center;
  height: .7rem;
  line-height: .7rem;
  color: #fff;
  background: #f48243;
  font-size: .3rem;
  border-radius: 0.08rem;
}

</style>
